import React, { Component } from 'react';
import moment from 'moment';
import SashiDo from 'lib/SashiDo';

import BarChart from 'components/Charts/BarChart.react';
import SegmentSelect from 'components/SegmentSelect/SegmentSelect.react';

export default class Graph extends Component {
  constructor(props) {
    super(props);

    this.state = {
      segmentTime: '30',
    };

    const today = moment().toDate();
    const nextBillingAt = moment.unix(props.currentCustomer.subscription.next_billing_at);



    if(today >= nextBillingAt.toDate()) {
      this.billingDate = nextBillingAt.format('YYYY-MM-DD');
    } else {
      this.billingDate = nextBillingAt.subtract(1, 'month').format('YYYY-MM-DD');
    }
  }

  componentDidMount() {
    this.resolutionChange(this.state.segmentTime)
  }

  resolutionChange(time) {
    const { last30Days, last12Months } = this.props.data;

    this.setState({
      data: time === '30' ? last30Days : last12Months,
      segmentTime: time,
    })
  }

  render() {
    return (
      <BarChart
        title={this.props.title}
        desc={this.props.desc}
        tooltip={this.props.tooltip}
        type={this.props.chartType || 'bar'}
        unit={this.props.unit}
        billingDate={this.billingDate}
        stacked={this.props.stacked}
        dataFormat={this.props.dataFormat}
        toolTipDataFormat={this.props.toolTipDataFormat}
        segmentTime={this.state.segmentTime}
        data={this.state.data}
        height={300}
        segmentTimeComponent={
          <SegmentSelect
            labels={['Last 30 Days', 'Last 12 Months']}
            values={['30', '12']}
            current={this.state.segmentTime || ''}
            onChange={(time) => {
              this.resolutionChange(time);
            }} />
        }
        colors={this.props.colors}
      />
    );
  }
}
